import PropTypes from "prop-types";
import { useState } from "react";
import { Button, Input, notification, SettingsCard } from "top-component-library";
import { DAY_LABELS, SCHEDULE_PLACEHOLDER } from "../constants";
import { DAY_ORDER, parseWeeklySchedule } from "../scheduleUtils";
import { DayError, DayField, SaveRow } from "../styles";

const seedInputs = (station) => {
  const inputs = {};
  for (const day of DAY_ORDER) {
    inputs[day] = station.station_schedule?.[day]?.customer_input ?? "";
  }
  return inputs;
};

// One prep station's weekly hours: 7 free-text day inputs, validated and
// normalized on save through parseWeeklySchedule (the characterized parser).
const StationScheduleCard = ({ station, onSave }) => {
  const [inputs, setInputs] = useState(() => seedInputs(station));
  const [errors, setErrors] = useState({});

  const handleSave = () => {
    const schedule = {};
    for (const day of DAY_ORDER) {
      schedule[day] = { customer_input: inputs[day], military_times: [] };
    }
    const result = parseWeeklySchedule(schedule);
    if (!result.userScheduleIsValid) {
      setErrors(result.errors);
      notification.error({ message: "Your Prep Station times are not valid. Please see the examples." });
      return;
    }
    setErrors({});
    onSave(station.station_id, result.scheduleAsMilitaryTime);
  };

  return (
    <SettingsCard title={`TOP by DoorDash Station: ${station.station_name}`}>
      <div>
        {DAY_ORDER.map((day) => (
          <DayField key={day}>
            <label htmlFor={`${station.station_id}-${day}`}>{DAY_LABELS[day]}</label>
            <Input
              id={`${station.station_id}-${day}`}
              placeholder={SCHEDULE_PLACEHOLDER}
              value={inputs[day]}
              onChange={(event) => setInputs({ ...inputs, [day]: event.target.value })}
            />
            {errors[day] && <DayError>{errors[day]}</DayError>}
          </DayField>
        ))}
        <SaveRow>
          <Button type="primary" onClick={handleSave}>
            Save {station.station_name}
          </Button>
        </SaveRow>
      </div>
    </SettingsCard>
  );
};

StationScheduleCard.propTypes = {
  station: PropTypes.object.isRequired,
  onSave: PropTypes.func.isRequired,
};

export default StationScheduleCard;
